import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import CopyTitleAndLinkButton from 'src/components/molecules/CopyTitleAndLinkButton'
import ShareButtons from 'src/components/molecules/ShareButtons'
import BlogPostLayout from 'src/components/organisms/blog/BlogPostLayout'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint } from 'src/components/shared/CssValues'

const BlogArticle = ({ title, url, articleHtml }) => {
  const copyButtonProps = {
    copiedText: `${title}\n${url}`,
    value: 'この記事のタイトルとURLをコピーする'
  }

  return (
    <Contents>
      <Title as="h1">{title}</Title>

      <CopyTitleAndLinkButton {...copyButtonProps} />
      <ShareButtons title={title} url={url} />

      <BlogPostLayout html={articleHtml} />

      <ShareButtons title={title} url={url} />
      <CopyTitleAndLinkButton {...copyButtonProps} />
    </Contents>
  )
}
const contentsLayoutCss = css`
  margin-top: 200px;
  margin: 0 auto;
  max-width: 660px;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    margin: 0 6%;
  }
`

const Contents = styled.div`
  ${contentsLayoutCss}
  text-align: center;
  padding: 96px 0;
`

const Title = styled(Typography)`
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.76px;
  text-align: center;
  color: #22475d;
`

export default BlogArticle
